export enum LocalStorageKeys {
  RUNNER = "runner",
  RUNS = "runs",
}
